import React, { Component } from 'react';

import callApi from '../../../utils/callApi';

import NewsHomeComponentItem from './NewsHomeComponentItem';

import { BASE_URL, FEATURED_LIST_BLOGPOSTS } from '../../../constants/apiUrls/apiUrls';

import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import './NewsHomeComponent.css';

class NewsHomeComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newsItems: [],
      isLoading: true,
      size: 5
    };
  }

  componentDidMount() {
    this.fetchFeaturedItemsList();
  }

  fetchFeaturedItemsList = () => {
    const { size } = this.state;
    let url = `${BASE_URL}/rest/v1/blog/preview?page=0&size=${size}`;
    callApi(url, 'get', {}).then(res => {
      this.setState({
        newsItems: res.data.blogs,
        isLoading: false
      });
    });
  };

  renderNewsItems = items => items.map((el, ind) => {
    const url = `/${el.slug}---${el.id}`;
    return <NewsHomeComponentItem
      key={el + ind}
      thumbnailImageUrl={el.imageUrl}
      imageUrl={el.imageUrl}
      url={url}
      name={el.title}
  />});

  render() {
    const { newsItems } = this.state;
    return (
      <div className="news-container">
        <div className="news-title">
          <h3><a href="/news">NEWS</a></h3>
          <div />
        </div>
        {newsItems.length > 0 && this.renderNewsItems(newsItems)}
        <div>
            <a href='/news' className='button-see-more'>
              <h4>SEE MORE</h4><ArrowForwardIosIcon/> 
            </a>
          </div>
      </div>
    );
  }
}

export default NewsHomeComponent;